
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapState } from 'vuex';
    import PatientSsnoSearch from './PatientSsnoSearch.vue';
    import ElgaPatient from '@/types/soap/elga/Patient';
    import { Resettable } from '@/types/Components';

    type PatientenSearchItem = ElgaPatient & { divider?: boolean };

    @Component({
        components: {
            PatientSsnoSearch,
        },
        computed: {
            ...mapState('patient', ['loaders']),
        },
    })
    export default class PatientenregisterSuche extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            search: Resettable;
        };

        public searchResult: PatientenSearchItem[] = [];
        public patient = new ElgaPatient();
        public curIndex = 0;

        public get patienten(): ElgaPatient[] {
            return this.searchResult.filter(({ divider }) => divider === undefined);
        }

        public get selectedPatient(): ElgaPatient {
            return this.patienten[this.curIndex] ?? new ElgaPatient();
        }

        public get foundPatient(): boolean {
            return !!this.patient.bPK;
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.patient = new ElgaPatient();
                this.searchResult = [];
                this.curIndex = 0;
            }

            if (this.$refs.search) {
                this.$refs.search.reset();
            }
        }

        public onSelectPatient(patient: ElgaPatient | undefined): void {
            if (patient) {
                this.patient = patient;
                const index = this.patienten.findIndex(({ ssno }) => ssno === this.patient.ssno);
                if (index !== -1) {
                    this.curIndex = index;
                }
            }
        }
    }
